export default __webpack_public_path__ + "static/media/6.d03377c5.png";